module.exports = __webpack_public_path__ + "static/img/NU.59043cff.svg";